var render = function render(){var _vm=this,_c=_vm._self._c;return _c('type-form',{attrs:{"group-type":_vm.newType}})
}
var staticRenderFns = []

export { render, staticRenderFns }